import { PairsV4 } from '@ui/services/contract/hooks/PairsManagerFacet/usePairsV4';
import BigNumber from 'bignumber.js';

/**
 * Mirror of TradingPortalFacet `_marginLeverage`: returns the first tier whose
 * notional cap covers `notionalUsd`, falling back to the last tier if none do.
 * Tiers are read in stored order to match the contract's iteration.
 *
 * Uses `notionalUsdBuffered` (the contract value × (1 - MAX_OI_CHECK_BUFFER))
 * so off-chain vs on-chain price drift cannot push the position into a
 * higher tier than the contract picks.
 */
export const getLeverageMarginByNotional = ({
  leverageMargins,
  notionalUsd,
}: {
  leverageMargins: PairsV4['leverageMargins'];
  notionalUsd: BigNumber;
}) => {
  if (leverageMargins.length === 0) return undefined;

  for (const tier of leverageMargins) {
    if (notionalUsd.lte(tier.notionalUsdBuffered)) {
      return tier;
    }
  }

  return leverageMargins[leverageMargins.length - 1];
};
